import type { ReactNode } from 'react';
import styles from './WidgetWrapper.module.css';

interface WidgetWrapperProps {
  title?: string | null;
  children: ReactNode;
}

export default function WidgetWrapper({ title, children }: WidgetWrapperProps) {
  return (
    <div className={styles.widget}>
      {title && (
        <div className={styles.titleBar}>
          <span className={styles.title}>{title}</span>
        </div>
      )}
      <div className={styles.body}>{children}</div>
    </div>
  );
}
